import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";
import {
  allowReabonnement,
  createAbonnementDirect,
  findAbonnementData,
  findAllAbonnements,
  findDernierAbonnement,
  getAttestationCiteoFile,
  getAttestationLekoFile,
  getAttestationSnaFile,
} from "../services/abonnements.service";
import {
  AbonnementDataResult,
  DernierAbonnementResult,
  HistoriqueAbonnementsResult,
  ReabonnementDisponibleResult,
} from "../interfaces/abonnements.interface";
import {
  ksAllowReabonnementQK,
  ksDernierAbonnementQK,
  ksHistoriqueAbonnementsQK,
  ksSabonnerDataQK,
} from "../query-keys";

type QueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

export const useDernierAbonnement = (options?: QueryOptions<DernierAbonnementResult>) =>
  useQuery({
    queryKey: [ksDernierAbonnementQK],
    queryFn: findDernierAbonnement,
    ...options,
  });

export const useAllowReabonnement = (options?: QueryOptions<ReabonnementDisponibleResult>) =>
  useQuery({
    queryKey: [ksAllowReabonnementQK],
    queryFn: allowReabonnement,
    ...options,
  });

export const useHistoriqueAbonnements = (options?: QueryOptions<HistoriqueAbonnementsResult>) =>
  useQuery({
    queryKey: [ksHistoriqueAbonnementsQK],
    queryFn: findAllAbonnements,
    ...options,
  });

export const useAbonnementData = (options?: QueryOptions<AbonnementDataResult>) =>
  useQuery({
    queryKey: [ksSabonnerDataQK],
    queryFn: findAbonnementData,
    ...options,
  });

export const useCreateAbonnementDirect = () =>
  useMutation({
    mutationFn: createAbonnementDirect,
  });

export const useAttestationSnaFile = () =>
  useMutation({
    mutationFn: (abonnementId: string) => getAttestationSnaFile(abonnementId),
  });

export const useAttestationCiteoFile = () =>
  useMutation({
    mutationFn: (abonnementId: string) => getAttestationCiteoFile(abonnementId),
  });

export const useAttestationLekoFile = () =>
  useMutation({
    mutationFn: (abonnementId: string) => getAttestationLekoFile(abonnementId),
  });
